<template>
    <CRow>
        <CCol col="12" lg="8">
            <CCard>
                <CCardHeader>
                    <strong>Создание продукта</strong>
                </CCardHeader>
                <CCardBody>
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CInput
                            v-model="product.title"
                            label="Название"
                            placeholder="Введите название продукта"
                        />
                        <CInputFile
                            ref="picture"
                            label="Изображение"
                            horizontal
                            @change="selectPicture"
                        />
                        <CTextarea
                            v-model="product.description"
                            label="Описание"
                            placeholder="Краткое описание продукта (не более 255 символов)"
                        />
                        <CInput
                            v-model="product.cart_button_title"
                            label="Кнопка «В корзину», текст"
                            placeholder="Текст на кнопке"
                        />
                        <CInput
                            v-model="product.cart_button_link"
                            label="Кнопка «В корзину», ссылка"
                            placeholder="Ссылка кнопки"
                        />
                        <CInput
                            v-model="product.lead_time"
                            label="Время выполнения"
                        />
                        <CInput
                            v-model="product.quantity"
                            label="Количество (шт)"
                        />
                        <CInput
                            v-model="product.composition"
                            label="Состав"
                            placeholder="Состав продукта (не более 255 символов)"
                        />
                        <CInput
                            v-model="product.allergens"
                            label="Содержит"
                            placeholder="Аллергены, если есть (не более 255 символов)"
                        />
                        <CInput
                            v-model="product.options_limit"
                            label="Доступное количество опций (шт)"
                            placeholder="12"
                        />
                        <CInput v-model="product.price" label="Цена" />

                        <CSelect
                            :value.sync="product.vat"
                            :horizontal="true"
                            :options="vatOptions"
                            label="Значения ставки НДС"
                            placeholder="Выберите значения ставки НДС"
                        />

                        <CSelect
                            label="Единицы измерения"
                            :options="unitsOptions"
                            :value.sync="product.units"
                            placeholder="Выберите единицы измерения..."
                        />

                        <CInput v-model="product.weight" :label="`Вес (${UNITS_ENUM[product.units]})`" />

                        <CInput v-model="product.calories" label="Килокалории (ккал)" />

                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать цену "От"
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="product.show_min_sum"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Энергетик (18+)
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="product.energetic"
                                />
                                <small class="form-text text-muted">
                                    Отметьте, если продукт является энергетиком или требует подтверждения возраста 18+
                                </small>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Популярное блюдо
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="product.popular"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="product.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create"
                    >Создать</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { UNITS_ENUM, UNITS } from '@/utils/units';

    export default {
        name: 'EntityProductCreate',

        data() {
            return {
                entity: {},
                product: {
                    entity_id: '',
                    external_id: '',
                    title: '',
                    picture: '',
                    description: '',
                    lead_time: '',
                    quantity: null,
                    options_limit: null,
                    composition: '',
                    show_min_sum: false,
                    allergens: '',
                    price: null,
                    units: UNITS.GRAM,
                    weight: null,
                    calories: null,
                    popular: false,
                    enabled: true,
                    position: 100,
                    energetic: false,
                    vat: null,
                    cart_button_title: null,
                    cart_button_link: null,
                },
                selectedPicture: null,
                UNITS_ENUM,
                vatOptions: [
                    { value: null, label: 'НДС не облагается' },
                    { value: 0, label: 'НДС 0%' },
                    { value: 5, label: 'НДС 5%' },
                    { value: 10, label: 'НДС 10%' },
                    { value: 20, label: 'НДС 20%' },
                    { value: 110, label: 'Расчетный НДС 10/110' },
                    { value: 120, label: 'Расчетный НДС 20/120' },
                ]
            };
        },

        computed: {
            unitsOptions() {
                return Object.entries(UNITS_ENUM).map(([value, label]) => ({ value, label }));
            }
        },

        mounted() {
            const id = parseInt(this.$route.params.id);
            Vue.axios
                .get(`/entities/get/${id}`)
                .then(resp => {
                    this.entity = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },

            async create() {
                if (!this.product.title) {
                    this.$root.$emit('showError', 'Укажите название продукта.');
                    return;
                }
                if (!this.product.price) {
                    this.$root.$emit('showError', 'Укажите стоимость.');
                    return;
                }
                if (!this.product.weight) {
                    this.$root.$emit('showError', 'Укажите вес.');
                    return;
                }
                if (!this.product.calories) {
                    this.product.calories = 0;
                }

                // Загружаем картинку
                if (this.selectedPicture) {
                    const this_ = this;
                    let formData = new FormData();
                    formData.append('file', this.selectedPicture);
                    const { data } = await Vue.axios.post('/files/upload', formData);
                    this_.product.picture = data.filename;
                } 
                Vue.axios
                    .post(
                        `/entities/${this.entity.id}/entity_products/create`,
                        this.product
                    )
                    .then(resp => {
                        this.$router.push({
                            path: `/entities/${this.entity.entityType.code}/${this.entity.id}/products/${resp.data.id}`
                        });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            goBack() {
                this.$router.push({
                    path: `/entities/${this.entity.entityType.code}/${this.entity.id}/products/`
                });
            },
        },
    };
</script>
